import { useIntl } from 'react-intl';

import Lozenge from '@atlaskit/lozenge';

import { messages } from './lozenges.i18n';

export const PremiumLozenge = () => {
  const { formatMessage } = useIntl();

  return (
    <Lozenge appearance="default">{formatMessage(messages.premium)}</Lozenge>
  );
};
